import React from 'react'

export default () => (
  <div className='page bg--pink p-3'>
    <h1>Þessi síða er ekki til</h1>
    <h3>404</h3>
  </div>
)
